var isBuffer = {exports: {}};

export { isBuffer as __module };
